import React, { useCallback, useMemo } from "react";

import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { FilterModel } from "@mapmycustomers/shared/types/viewModel/internalModel/FilterModel";
import SortModel from "@mapmycustomers/shared/types/viewModel/internalModel/SortModel";

import ListOrderSelect from "@app/component/resources/ListOrderSelect";
import ResourceTypeFilter from "@app/component/resources/ResourceTypeFilter";
import ResourceContentType from "@app/component/resources/ResourceTypeFilter/ResourceContentType";
import ResourceType from "@app/enum/ResourceType";

import FolderFilter from "./FolderFilter";
import styles from "./Toolbar.module.scss";

interface ToolbarProps {
  filter: FilterModel;
  onFilterChange: (filter: FilterModel) => void;
  onSortChange: (sort: SortModel) => void;
  resourceTypes?: ResourceType[];
  sort: SortModel;
}

const Toolbar = ({ filter, onFilterChange, onSortChange, resourceTypes, sort }: ToolbarProps) => {
  const handleSortChange = useCallback(
    (field: IField, order: SortOrder) => {
      onSortChange([{ field, order }]);
    },
    [onSortChange]
  );

  const contentTypes = useMemo(() => {
    const contentTypes = new Set(Object.values(ResourceContentType));
    if (!resourceTypes?.includes(ResourceType.FILE)) {
      contentTypes.clear();
    }

    if (resourceTypes?.includes(ResourceType.LINK)) {
      contentTypes.add(ResourceContentType.LINK);
    }

    return Array.from(contentTypes);
  }, [resourceTypes]);

  return (
    <div className={styles.toolbar}>
      <div className={styles.filters}>
        <FolderFilter filter={filter} onChange={onFilterChange} />
        <ResourceTypeFilter contentTypes={contentTypes} filter={filter} onChange={onFilterChange} />
      </div>
      <ListOrderSelect onChange={handleSortChange} sort={sort} />
    </div>
  );
};

export default Toolbar;
